module.exports = __webpack_public_path__ + "assets/27afe69cfbfa01e3b05968d1153d4596.png";